module.exports = __webpack_public_path__ + "static/media/icon-table-sorter.1a65a0e5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/icon-table-sorter.svg
// module id = 1851
// module chunks = 0